import {capitalize, compact, reduce} from 'lodash'
import fbShare from './fb-share'

const CLASS_BTN_ACTIVE = 'share-button--is-active'
const CLASS_MEDIA_ACTIVE = 'share-button-media--is-active'
const CLASS_DARK = 'share-button-media--dark'
const CLASS_SHARE_BTN = 'share-button__link'

const encodeURI = window.encodeURI

export default (selector = '[data-share]', dark = false) => {

  fbShare()

  const $button = $(selector)

  if ($button.length === 0 || typeof $button.attr('data-share-sources') === 'undefined') {
    // console.warn(`Missing or invalid selector \`${selector}\` (share-button)`)
    return
  }

  const sources = String($button.attr('data-share-sources')).split(' ')
  const template = templatize(compact(sources))
  const $template = $(template)

  if (dark) {
    $template.addClass(CLASS_DARK)
  }

  $button.after($template)

  $button.on('click', (event) => {
    $(event.currentTarget).toggleClass(CLASS_BTN_ACTIVE)
    $(event.currentTarget).siblings('.share-button-media').toggleClass(CLASS_MEDIA_ACTIVE)
  })

  $('[data-share-dest]').on('click', (event) => {
    const shareDest = $(event.currentTarget).attr('data-share-dest')
    const shareUrl = $(event.currentTarget).parent().siblings(selector).attr('data-share') || location.href
    const shareMedia = $(event.currentTarget).parent().siblings(selector).attr('data-share-media')
    share(shareDest, shareUrl, shareMedia)
  })
}

function share(source, shareUrl, shareMediaUrl) {
  switch (source) {
    case 'facebook':
      FB.ui({ method: 'share', href: shareUrl })
      break
    case 'twitter':
      window.open(`https://twitter.com/share?text=${''}&url=${encodeURI(shareUrl)}&hashtags=fooandfoo`, 'Twitter', 'width=600, height=300')
      break
    case 'pinterest':
      if (window.PinUtils) {
        window.PinUtils.pinOne({
          url: shareUrl,
          description: 'Foo and Foo',
        })
      } else {
        console.warn(`Couldn't find window.PinUtils. Falling back.`)
        window.open(`https://pinterest.com/pin/create/button/?url=${encodeURI(shareUrl)}`, 'Pinterest', 'width=760, height=600')
      }
      break
  }
}

function templatize(items) {
  const compiled = reduce(items, (a, item) => a + `<button class="${CLASS_SHARE_BTN}" data-share-dest="${item}">${capitalize(item)}</button>`, '')
  return `<span class="share-button-media">${compiled}</span>`
}



// WEBPACK FOOTER //
// ./share-button.js